import { render, staticRenderFns } from "./ArticleInfoCoverPaywall.vue?vue&type=template&id=6fc52bc0"
import script from "./ArticleInfoCoverPaywall.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoCoverPaywall.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports